import React from "react";
import styled from "styled-components";
import { InvestmentCalculator } from "./InvestmentCalculator";
import { resource } from "@app/common/localization/resource";

export const SectionCalculator: React.VFC = () => (
  <StyledSection>
    <div className="container">
      <h1>{resource("landing.section2Title")}</h1>
      <InvestmentCalculator />
    </div>
  </StyledSection>
);

const StyledSection = styled.section`
  background: #f7f7f7;
  padding: 80px 0;

  h1 {
    margin-bottom: 60px;
    font-size: 32px;
    font-weight: 700;
    color: var(--heading-color);
    text-align: center;
  }

  .lead {
    margin: 0 0 50px;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
  }
`;
